import { track } from './utils/analytics';

document.addEventListener('DOMContentLoaded', () => {
	// HTML5 videos
	// Note that all videos above login require the wrapper div <div class="video-player__container">
	if (document.querySelector('.video-player__container')) {
		document.querySelectorAll('.video-player__container').forEach(function(videoContainer) {
			videoContainer = videoContainer || document.body;

			var cachedVideoSources = [];
			var videoPlayerElement = videoContainer.querySelector('.video-player');
			var classId = videoPlayerElement.getAttribute('data-id');
			var posterImage = videoPlayerElement.getAttribute('data-poster');
			var videoPlayerElementId = videoPlayerElement.getAttribute('id');
			var sharedClassComplete = document.querySelector('.class__shared-complete');
			var onValidSharePage = !!sharedClassComplete;
			var sentShareViewedRequest = false;
			var music = null;
			var isMuted = false;
			var isMusicMuted = false;
			var audioMixVolume = 80;
			var audioMixBalance = 75;
			var cachedAudioMixBalance = 50;
			var isTapped = false;
			var videoOverlay = videoContainer.querySelector('.video-overlay-screen');
			var loaderOverlay = videoContainer.querySelector('.loader-overlay');
			var errorOverlay = videoContainer.querySelector('.video-error-screen');

			function checkVideoResolution(video, filenameFragment, resolution) {
				if (video.url.includes(filenameFragment)) {
					if (video.url.includes('.mp4') || video.url.includes('cloudfront.net/?Expires=') === false) return true;
				}

				if (video.resolution === resolution) return true;
			}

			function getMusicUrl() {
				const musicUrl = videoContainer.querySelector('.video-player__source').getAttribute('data-music-url');
				if (musicUrl) music = new Audio(musicUrl);
			}

			function pauseMusicIfExists() {
				if (music) music.pause();
			}

			if (onValidSharePage) {
				document.querySelector('.class__shared-complete-close').addEventListener('click', function() {
					sharedClassComplete.classList.add('hide');
				});
			}

			if (videoContainer.querySelector('.video-player__source')) {
				var videoType = videoPlayerElement.getAttribute('data-video-type');
				var updateShare = function(shareData) {
					var shareId = window.location.pathname.split('/')[2];

					// Success/error handling intentionally not included.
					// We have server-side logging for this
					fetch('/proxy/v1/updateShare', {
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json'
						},
						method: 'PATCH',
						body: JSON.stringify({
							shareId: shareId,
							shareData: shareData
						})
					});
				};

				var getVideoSources = function() {
					var src = [];
					var videos = [];
					var videoPlayerSourceEls = videoContainer.querySelectorAll('.video-player__source');

					videoPlayerSourceEls.forEach(function(vid) {
						videos.push({
							url: vid.getAttribute('data-url'),
							resolution: vid.getAttribute('data-resolution')
						});
					});

					if (videos.length === 1 || videoType === 'teacher bio') {
						src.push({ file: videos[0].url });
					} else {
						var hls = videos.find(function(video) { return video.url.indexOf('m3u8') > -1; });
						var hd = videos.find(function(video) { return checkVideoResolution(video, 'full', '1080p'); });
						var sd = videos.find(function(video) { return checkVideoResolution(video, 'high', '720p'); });
						var low = videos.find(function(video) { return checkVideoResolution(video, 'low', '480p'); });
						var basic = videos.find(function(video) { return checkVideoResolution(video, 'basic', '360p'); });

						if (!sd) {
							sd = videos.find(function(video) { return checkVideoResolution(video, 'medium', '720p'); });
						}

						if (hls) src.push({ file: hls.url, label: 'HLS' });

						// If the vidSource exists & the signed url was created correctly, create the video element
						// We know that if the vidSource contains 'mp4', the file should exist
						// We know that if the vidSource contains 'cloudfront.net/?Expires=', the file *doesn't* exist
						if (hd) src.push({ file: hd.url, label: 'HD' });
						if (sd) src.push({ file: sd.url, label: 'SD', default: true });
						if (low) src.push({ file: low.url, label: 'Low' });
						if (basic) src.push({ file: basic.url, label: 'Basic' });
					}

					cachedVideoSources = src;

					var showTermsOverlay = videoContainer.classList.contains('video-player__container--terms');

					if (showTermsOverlay) {
						const emailInput = document.querySelector('.video-tc-gate__input-email');
						const submitButton = document.querySelector('.video-tc-gate__tc-container .btn');

						videoOverlay.classList.remove('hide');
						videoContainer.querySelector('.video-tc-gate__container').classList.remove('hide');

						// For referral v2
						if (emailInput) {
							emailInput.focus();

							emailInput.addEventListener('input', (event) => {
								const value = event.target.value;

								if (value) {
									submitButton.hasAttribute('disabled') && submitButton.removeAttribute('disabled');
								} else {
									submitButton.setAttribute('disabled', '');
								}
							});

							videoContainer.querySelector('.video-tc-gate__tc-container .btn').addEventListener('click', function(e) {
								e.preventDefault();

								if (emailInput.validity.typeMismatch) {
									emailInput.reportValidity();
									return;
								}

								if (onValidSharePage && !sentShareViewedRequest) {
									const currentHref = document.querySelector('.content-container--cta .btn').href;

									updateShare({
										referredEmail: emailInput.value,
										viewed: true
									});
									sentShareViewedRequest = true;

									document.querySelector('.content-container--cta .btn').href = `${currentHref}/${emailInput.value}`;
									document.querySelector('.class__shared-complete-email').setAttribute('value', emailInput.value);
								}

								setTimeout(function() {
									videoOverlay.classList.add('hide');
									videoContainer.querySelector('.video-tc-gate__container').remove();
									videoContainer.classList.remove('video-player__container--terms');

									jwplayer(videoPlayerElementId).play();
								}, 500);

								track('Referral - email filled out on gifted class', {
									category: 'activity',
									label: classId,
									platform: 'web'
								});
							});
						} else { // Old referral flow
							videoContainer.querySelector('.video-tc-gate__tc-container').addEventListener('click', function(e) {
								e.preventDefault();

								setTimeout(function() {
									videoOverlay.classList.add('hide');
									videoContainer.querySelector('.video-tc-gate__container').remove();
									videoContainer.classList.remove('video-player__container--terms');

									jwplayer(videoPlayerElementId).play();
								}, 500);
							});
						}
					}

					initVideoPlayer(posterImage, classId, src, videoContainer);
				};

				var initVideoPlayer = function(posterImage, classId, sourceObjects, videoContainer, isAutoplay) {
					var userAgent = document.getElementById('userAgent').getAttribute('data-useragent');
					var browserName, androidDevice;

					try {
						userAgent = JSON.parse(userAgent);
						browserName = userAgent.browser.name.toLowerCase();
						androidDevice = userAgent.os.name === 'Android';
					} catch (err) {/* Fail silently */ }

					// JWPlayer configuration
					var autostart = isAutoplay && !window.isTouch();
					var isAndroidFF = androidDevice && browserName === 'firefox';
					var jwPlayerOptions = {
						sources: sourceObjects,
						skin: {
							name: 'glo'
						},
						autostart: autostart,
						timeSliderAbove: false,
						preload: 'auto',
						image: posterImage,
						aspectratio: '16:9',
						width: '100%',
						repeat: false,
						playbackRateControls: [0.5, 0.75, 1, 1.25, 1.5, 2],
						stretching: 'fill',
						controls: true,
						androidhls: androidDevice ? !isAndroidFF : null,
						hlsjsdefault: isAndroidFF
					};

					var videoPlayer = jwplayer(videoPlayerElementId).setup(jwPlayerOptions);

					var setVolume = () => {
						var mixVolume = audioMixVolume / 100;

						if (isMuted) return;

						if (audioMixBalance <= 50) {
							music.volume = mixVolume;
							videoPlayer.setVolume((audioMixBalance * 2) * mixVolume);
						} else {
							music.volume = (100 - ((audioMixBalance - 50) * 2)) / 100 * mixVolume;
							videoPlayer.setVolume(100 * mixVolume);
						}

						setVolumeIcon();
						setAriaLabel();
						setAriaLabel(true);
					};

					var setVolumeIcon = () => {
						var iconName = audioMixVolume === 0 || isMuted ? 'muted-volume' : audioMixVolume > 50 ? 'volume' : 'half-volume';
						var iconElement = videoContainer.querySelector('.icon--volume');
						var imgSrc = iconElement.getAttribute('src').split('/');

						imgSrc.pop();
						iconElement.setAttribute('src', `${imgSrc.join('/')}/${iconName}.svg`);
					};

					var setMusicIcon = () => {
						var iconName = isMusicMuted ? 'muted-mixer' : 'mixer';
						var iconElement = videoContainer.querySelector('.music-icon');
						var imgSrc = iconElement.getAttribute('src').split('/');

						imgSrc.pop();
						iconElement.setAttribute('src', `${imgSrc.join('/')}/${iconName}.svg`);
					};

					var setAriaLabel = (isMusic) => {
						let label;

						if (isMusic) {
							label = isMusicMuted ? 'Unmute music' : 'Mute music';
							videoContainer.querySelector('.video-player-sound-mixer__mixer-btn').setAttribute('aria-label', label);
						} else {
							label = isMuted ? 'Unmute' : 'Mute';
							videoContainer.querySelector('.video-player-sound-volume__volume-btn').setAttribute('aria-label', label);
						}
					};

					var muteAudio = () => {
						isMuted = !isMuted;
						videoPlayer.setMute(isMuted);

						// Only unmute the music track if it's not muted separately from the master volume
						if (!isMusicMuted) music.muted = isMuted;

						if (isMuted) {
							videoContainer.querySelector('.video-player-sound-volume__container-absolute #video-volume-input').value = 0;
						} else {
							videoContainer.querySelector('.video-player-sound-volume__container-absolute #video-volume-input').value = audioMixVolume;
						}

						setVolumeIcon();
						setAriaLabel();

						if (!isMuted && audioMixVolume === 0) {
							setAudioMixVolume({
								target: {
									value: 10
								}
							});
						}
					};

					var muteMusic = () => {
						isMusicMuted = !isMusicMuted;

						// Only unmute the music track if the master volume isn't muted
						if (!isMuted) music.muted = isMusicMuted;

						if (isMusicMuted) {
							cachedAudioMixBalance = audioMixBalance;
							audioMixBalance = 100;
						} else {
							audioMixBalance = cachedAudioMixBalance;
						}

						setAudioMixBalance({
							target: {
								value: audioMixBalance
							}
						});

						setMusicIcon();
						setAriaLabel(true);
					};

					var setAudioMixBalance = (e) => {
						isMusicMuted = parseInt(e.target.value, 10) === 100;
						audioMixBalance = e.target.value;

						// Only unmute the music track if the master volume isn't muted
						if (!isMuted) music.muted = isMusicMuted;

						videoContainer.querySelector('.video-player-sound-mixer__slider #video-mixer-input').value = audioMixBalance;

						setVolume();
					};

					var setAudioMixVolume = (e) => {
						audioMixVolume = e.target.value;
						setVolume();
					};

					var setAudioVolumeByKey = (e) => {
						const arrowStep = 5;
						var newAudioMixVolume;

						// Down arrow key
						if (e.which === 40) {
							e.stopPropagation();
							e.preventDefault();
							newAudioMixVolume = audioMixBalance - arrowStep < 0 ? 0 : audioMixBalance - arrowStep;

							setAudioMixVolume({
								target: {
									value: newAudioMixVolume
								}
							});
						}
						// Up arrow key
						else if (e.which === 38) {
							e.stopPropagation();
							e.preventDefault();
							newAudioMixVolume = audioMixVolume + arrowStep >= 100 ? 100 : audioMixVolume + arrowStep;

							setAudioMixVolume({
								target: {
									value: newAudioMixVolume
								}
							});
						}
						// Tab key
						else if (e.which === 9 && e.target.classList.contains('video-player-sound-volume')) {
							e.stopPropagation();
							videoContainer.querySelector('.video-player-sound-volume__container-absolute').classList.toggle('is-focus');
						}
						// Mute/unmute when "Enter" key is pressed
						else if (e.which === 13) {
							e.stopPropagation();
							muteAudio();
						}
					};

					var setAudioMixerBalanceByKey = (e) => {
						const arrowStep = 5;
						var newAudioMixBalance;

						// Left arrow key
						if (e.which === 37) {
							e.stopPropagation();
							newAudioMixBalance = audioMixBalance - arrowStep < 0 ? 0 : audioMixBalance - arrowStep;

							setAudioMixBalance({
								target: {
									value: newAudioMixBalance
								}
							});
						}
						// Right arrow key
						else if (e.which === 39) {
							e.stopPropagation();
							newAudioMixBalance = audioMixBalance + arrowStep > 100 ? 100 : audioMixBalance + arrowStep;

							setAudioMixBalance({
								target: {
									value: newAudioMixBalance
								}
							});
						}
						// Tab key
						else if (e.which === 9) {
							e.stopPropagation();
							videoContainer.querySelector('.video-player-sound-mixer__slider').classList.toggle('is-focus');
						}
						// Mute/unmute when "Enter" key is pressed
						else if (e.which === 13) {
							e.stopPropagation();
							muteMusic();
						}
					};

					var tapped = () => {
						if (!isTapped && music) {
							music.load();
							isTapped = true;
						}
					};

					var isIOS = () => {
						return [
							'iPad Simulator',
							'iPhone Simulator',
							'iPod Simulator',
							'iPad',
							'iPhone',
							'iPod'
						].includes(navigator.platform);
					};

					var soundVolumeEl;
					var soundMixerEl;

					var attachKeyEvents = () => {
						var soundVolumeContainer = videoContainer.querySelector('.video-player-sound-volume__container-absolute');

						// Attach event to change audio volume then focused on player
						document.querySelectorAll('.jwplayer').forEach(function(element) {
							element.addEventListener('keydown', function(e) {
								e.stopPropagation();
								if (e.target.classList.contains('jwplayer')) setAudioVolumeByKey(e);
							});
						});

						soundVolumeEl.addEventListener('focus', function() {
							this.classList.add('is-focus');
						});

						soundVolumeEl.addEventListener('blur', function(e) {
							if (e.relatedTarget && e.relatedTarget.classList[0] !== 'video-player-sound-volume__container-absolute') {
								soundVolumeContainer.classList.remove('is-focus');
							}

							this.classList.remove('is-focus');
						});

						soundVolumeEl.addEventListener('click', function() {
							soundVolumeContainer.classList.remove('is-focus');
							this.classList.remove('is-focus');
						});

						soundVolumeContainer.addEventListener('blur', function() {
							this.classList.remove('is-focus');
						});

						soundMixerEl.addEventListener('focus', function() {
							this.classList.add('is-focus');
						});

						soundMixerEl.addEventListener('blur', function(e) {
							if (e.relatedTarget && e.relatedTarget.classList[0] !== 'video-player-sound-mixer__slider') {
								videoContainer.querySelector('.video-player-sound-mixer__slider').classList.remove('is-focus');
							}

							this.classList.remove('is-focus');
						});

						soundMixerEl.addEventListener('click', function() {
							this.classList.remove('is-focus');
						});

						document.querySelector('.video-player-sound-mixer__slider').addEventListener('blur', function() {
							this.classList.remove('is-focus');
						});
					};

					videoPlayer.on('ready', function() {
						videoPlayerElement.classList.remove('hide');
						document.addEventListener('touchstart', tapped);

						if (music) {
							// Custom mixer's volume event
							videoContainer.querySelector('#video-volume-input').addEventListener('input', setAudioMixVolume);
							videoContainer.querySelector('#video-volume-input').value = audioMixVolume;

							// Custom mixer's balance event
							videoContainer.querySelector('#video-mixer-input').addEventListener('input', setAudioMixBalance);
							videoContainer.querySelector('#video-mixer-input').value = audioMixBalance;

							videoContainer.querySelector('.video-player-sound-volume__volume-btn').addEventListener('click', function(e) {
								e.preventDefault();
								muteAudio();
							});

							// Disabling the mixer on IOS devices and adding a mute option
							if (isIOS()) {
								audioMixBalance = 50;
								document.body.classList.add('is-ios');
							}

							videoContainer.querySelector('.video-player-sound-mixer__mixer-btn').addEventListener('click', function(e) {
								e.preventDefault();
								muteMusic();
							});


							// Remove volume icon and replace it with a custom
							if (!videoContainer.querySelector('.jw-button-container .video-player-sound-volume')) {
								videoContainer.querySelector('.jw-icon-volume').style.display = 'none';

								document.querySelector('.jw-button-container').insertBefore(videoContainer.querySelector('.video-player-sound-volume'), videoContainer.querySelector('.jw-button-container .jw-icon-next'));
								document.querySelector('.jw-button-container').insertBefore(videoContainer.querySelector('.video-player-sound-mixer'), videoContainer.querySelector('.jw-button-container .jw-icon-next'));

								soundVolumeEl = videoContainer.querySelector('.video-player-sound-volume');
								soundMixerEl = videoContainer.querySelector('.video-player-sound-mixer');

								soundVolumeEl.style.display = 'block';
								soundMixerEl.style.display = 'block';

								soundVolumeEl.addEventListener('keydown', setAudioVolumeByKey);
								soundMixerEl.addEventListener('keydown', setAudioMixerBalanceByKey);

								attachKeyEvents();
								setVolume();
							}
						}
					});

					videoPlayer.on('firstFrame', function() {
						if (document.querySelector('.program-trailer__wrapper')) {
							track('Program - Trailer Played', {
								program_name: document.querySelector('.content-details__title').innerText,
								program_id: window.location.pathname.split('/').pop()
							});
						}

						if (onValidSharePage) {
							track('share class client start class', {
								category: 'activity',
								label: classId,
								platform: 'web'
							});
						}
					});

					videoPlayer.on('play', function() {
						if (videoOverlay) videoOverlay.classList.add('hide');
						if (loaderOverlay) loaderOverlay.classList.add('hide');
						if (errorOverlay) errorOverlay.classList.add('hide');

						if (document.querySelector('.program-trailer__wrapper')) {
							document.querySelector('.program-trailer__wrapper').classList.remove('program-trailer__wrapper--small');
						}

						if (music) music.play();
					});

					videoPlayer.on('time', function() {
						if (music) {
							var videoPosition = videoPlayer.getPosition();

							if (videoPosition - music.currentTime >= 1 || videoPosition - music.currentTime < 0) {
								music.currentTime = videoPosition;
							}
						}
					});

					videoPlayer.on('buffer', function() {
						if (errorOverlay) errorOverlay.classList.add('hide');
						if (videoOverlay) videoOverlay.classList.remove('hide');
						if (loaderOverlay) loaderOverlay.classList.remove('hide');

						pauseMusicIfExists();
					});

					videoPlayer.on('setupError error', function(e) {
						var errorMessage = e.message;
						var errorMessageLower = errorMessage.toLowerCase();
						var hlsErrorMessageLower = 'Cannot load M3U8'.toLowerCase();

						// Hide the JWPlayer default errors
						document.querySelector('.jw-title').style.display = 'none';
						document.querySelector('.jw-display-container').style.display = 'none';

						if (document.querySelector('.program-trailer__overlay')) {
							document.querySelector('.program-trailer__overlay').style.display = 'none';
						}

						if (errorMessageLower.includes(hlsErrorMessageLower)) {
							var prunedVideoSources = cachedVideoSources.filter(function(cachedVideoSource) {
								return cachedVideoSource.type !== 'hls';
							});

							initVideoPlayer(posterImage, classId, prunedVideoSources);
						} else {
							if (loaderOverlay) loaderOverlay.classList.add('hide');
							if (videoOverlay) videoOverlay.classList.remove('hide');
							if (errorOverlay) errorOverlay.classList.remove('hide');

							if (videoContainer.querySelector('.video-tc-gate__container')) {
								videoContainer.querySelector('.video-tc-gate__container').classList.add('hide');
							}

							if (videoContainer.querySelector('.video-error-screen__message')) {
								videoContainer.querySelector('.video-error-screen__message').innerText = errorMessage;
							}
						}

						pauseMusicIfExists();
					});

					videoPlayer.on('seek', pauseMusicIfExists);

					videoPlayer.on('seeked', () => {
						if (music && videoPlayer.getState() !== 'paused') music.play();
					});

					if (onValidSharePage) {
						videoPlayer.on('complete', function() {
							sharedClassComplete.classList.remove('hide');

							updateShare({ completed: true });

							track('share class client complete class', {
								category: 'activity',
								label: classId,
								platform: 'web'
							});
						});
					} else {
						if (document.querySelector('.video-preview-cta__container')) {
							document.querySelector('.video-preview-cta__container').addEventListener('click', function(e) {
								if (e.target.classList.contains('btn')) return;
								videoPlayer.play();
							});
						}

						videoPlayer.on('pause complete', function() {
							if (document.querySelector('.video-preview-cta__container')) {
								videoOverlay.classList.remove('hide');
								videoContainer.querySelector('.video-preview-cta__container').classList.remove('hide');
							}

							pauseMusicIfExists();
						});
					}
				};

				getVideoSources();
				getMusicUrl();
			}
		});
	}
});
